import { gql } from '@apollo/client';

export const GET_PERFORMANCE_METRICS = gql`
  query GetPerformanceMetrics($date: Date!, $analysisTypeId: Float = 1) {
    performanceMetrics(date: $date, analysisTypeId: $analysisTypeId) {
      overall {
        firstPick {
          invested
          returned
          roi
          winners
          winRate
        }
        eachWay {
          invested
          returned
          roi
          winners
          placers
          winRate
          placeRate
        }
        valuePicks {
          invested
          returned
          roi
          winners
          winRate
        }
      }
      metropolitan {
        firstPick {
          invested
          returned
          roi
          winners
          winRate
        }
        eachWay {
          invested
          returned
          roi
          winners
          placers
          winRate
          placeRate
        }
      }
      provincial {
        firstPick {
          invested
          returned
          roi
          winners
          winRate
        }
        eachWay {
          invested
          returned
          roi
          winners
          placers
          winRate
          placeRate
        }
      }
      country {
        firstPick {
          invested
          returned
          roi
          winners
          winRate
        }
        eachWay {
          invested
          returned
          roi
          winners
          placers
          winRate
          placeRate
        }
      }
    }
  }
`;
